/**
 * Yotpo's injector is gated on `statistics` — see the `data-cookieconsent` attribute in
 * `yotpo__scripts-usa.liquid` / `yotpo__scripts-can.liquid`. Read the same category here so
 * the section's visibility and the widget's availability can never disagree.
 */
const YOTPO_CONSENT_CATEGORY = "statistics";

export default class YotpoHeader extends HTMLElement {
	constructor() {
		super();

		this.consentGate();
		this.init();
	}

	reviewPagesGotten = [];

	reviewData = [];

	async init() {
    // Apply helper classes, plus watch for changes
    this.yotpoMutationObserver(async () => {
			const activePage = document.querySelector("[page].selected")?.innerHTML;
			if (activePage) {
				// Data already in array
				if (this.reviewPagesGotten.indexOf(activePage) != -1) {
					this.addReviewClasses();
				// Get new data
				} else {
					this.reviewPagesGotten.push(activePage);
					const reviewData = await this.getReviewsDataByPage(activePage);

					this.reviewData = [...this.reviewData, ...reviewData.reviews];

					this.addReviewClasses();
				}
			}
    });
	}

	async getReviewsDataByPage(page = '1') {
		const response = await fetch(
			// // `https://api-cdn.yotpo.com/v1/widget/${this.dataset.appKey}/products/${this.dataset.productId}/reviews.json?per_page=150`,
			`https://api-cdn.yotpo.com/v3/storefront/store/${this.dataset.appKey}/product/${this.dataset.productId}/reviews?page=${page}&perPage=5&sort=date,images,badge,rating`,
			{
				headers: {
					"Content-Type": "application/json",
					// 'Content-Type': 'application/x-www-form-urlencoded',
				},
			}
		);
		const reviewData = await response.json();
		return reviewData;
	}

	addReviewClasses() {
		this.reviewData.map((review) => {
			const reviewRow = document.querySelector(
				`[data-id="${review.id}"]`
			);
			if (
				!!reviewRow &&
				review.isIncentivized &&
				review.incentiveType == "other"
			) {
				reviewRow?.classList.add("review--is-incentivized");
			}
		});
	}

	/**
	 * Without statistics consent the widget script never loads, so this section renders as
	 * an empty coloured band and the ticker above it becomes the page's closing element.
	 * Hide both until consent arrives, and follow it if the visitor changes their mind.
	 */
	consentGate() {
		const apply = () => this.applyConsent(!!(window.SSConsent && window.SSConsent[YOTPO_CONSENT_CATEGORY]));

		// global--consent-bridge runs inline in <head>, so window.SSConsent is already set by
		// the time this deferred bundle upgrades the element — its initial ss:consent has
		// been and gone. Read the current value, then follow any later Accept/Decline.
		apply();
		document.addEventListener("ss:consent", apply);
	}

	applyConsent(granted) {
		this.style.display = granted ? "" : "none";
		const tickers = document.querySelectorAll("scroll-ticker");

    // Only do this hide on PDP, when 2 scroll-tickers are present
		if (!document.body.classList.contains("template-product") || !tickers.length || tickers.length < 2) return;

    const ticker = tickers[0];
		const tickerSection = ticker && ticker.closest(".shopify-section");

		if (tickerSection) tickerSection.style.display = granted ? "" : "none";
	}

	yotpoMutationObserver(changed = () => {}) {
		const targetNodes = document
			.querySelectorAll(".shopify-app-block");

		targetNodes.forEach((targetNode) => {
			if (!targetNode.querySelector(".yotpo-widget-instance")) return;

			// Callback function to execute when mutations are observed
			const callback = (mutationList, observer) => {
				for (const mutation of mutationList) {
					if (mutation.type === "childList") {
						changed();
					} else if (mutation.type === "attributes") {
						// 	`The ${mutation.attributeName} attribute was modified.`
						// );
						// changed();
					}
				}
			};

			// Create an observer instance linked to the callback function
			const observer = new MutationObserver(callback);

			// Start observing the target node for configured mutations
			observer.observe(targetNode, {
				attributes: true,
				childList: true,
				subtree: true,
			});
		});
	}
}
